var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilloutPana({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 228.68,
    y: 94.7,
    width: 222.58,
    height: 313.37,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.36,60a29.63,29.63,0,0,1,7.23-3.14l1.49-7.16,12.1-.22,1.74,7.11a29.58,29.58,0,0,1,7.35,2.89l6.11-4,8.71,8.4-3.79,6.25a29.69,29.69,0,0,1,3.14,7.24l7.16,1.49.21,12.1-7.1,1.74a29.75,29.75,0,0,1-2.89,7.34l4,6.12-8.41,8.7-6.25-3.79a29.66,29.66,0,0,1-7.23,3.15l-1.49,7.16-12.1.21-1.74-7.1a29.75,29.75,0,0,1-7.34-2.89l-6.12,4-8.7-8.41,3.79-6.25a29.18,29.18,0,0,1-3.15-7.24l-7.16-1.49-.21-12.1,7.1-1.74a30.06,30.06,0,0,1,2.89-7.34l-4-6.11,8.41-8.71L422.36,60Zm6.45,16.12a13,13,0,1,0,18.35-.32A13,13,0,0,0,428.81,76.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.81,76.14A9.73,9.73,0,0,1,431.23,74a12.86,12.86,0,0,1,8.46-2,13.06,13.06,0,0,1,5.76,2,13.35,13.35,0,0,1,4.66,5.25A13.27,13.27,0,0,1,451.36,87a13.24,13.24,0,0,1-11,11.35,12.5,12.5,0,0,1-4,.06,12.29,12.29,0,0,1-3.68-1,13.22,13.22,0,0,1-5.4-4.47,13.1,13.1,0,0,1-.55-14.21,9.89,9.89,0,0,1,2-2.49c.07.06-.78.85-1.78,2.63a12.93,12.93,0,0,0-1.44,8.31,12.69,12.69,0,0,0,2.23,5.41,12.83,12.83,0,0,0,5.18,4.2,12.76,12.76,0,0,0,7.28.89,12.6,12.6,0,0,0,10.36-10.73,12.85,12.85,0,0,0-1.15-7.24,12.7,12.7,0,0,0-4.38-5,12.5,12.5,0,0,0-5.48-2,12.91,12.91,0,0,0-8.25,1.73C429.63,75.33,428.87,76.21,428.81,76.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.36,60a2.44,2.44,0,0,1-.4-.21l-1.2-.69L416,56.33l.15,0-8.35,8.76,0-.24,4,6.1L412,71l-.06.12a29.29,29.29,0,0,0-2.84,7.29l0,.14-.14,0-7.1,1.76.2-.26q.12,5.72.24,12.1L402,92l7.16,1.47.19,0,.05.18a29.06,29.06,0,0,0,3.12,7.15l.1.17-.1.17-3.78,6.25-.05-.41,8.71,8.4-.43,0,6.11-4,.18-.12.19.11a29.78,29.78,0,0,0,7.25,2.85l.21,0,.06.21c.54,2.22,1.14,4.65,1.74,7.1l-.36-.27,12.1-.22-.36.29,1.49-7.16.05-.22.22-.06a29.28,29.28,0,0,0,7.13-3.1h0l.2-.11.19.11,6.25,3.8-.46,0,8.4-8.7,0,.46-4-6.12-.13-.18.11-.2a29.28,29.28,0,0,0,2.86-7.24l.05-.22.21,0,7.11-1.73-.27.35q-.1-6.2-.2-12.1l.27.33-7.16-1.5-.2,0-.05-.2a29.6,29.6,0,0,0-3.1-7.16l-.1-.17L463,70l3.8-6.25.05.39-8.69-8.43.36,0-6.13,4-.13.09-.14-.08a29.33,29.33,0,0,0-7.27-2.88l-.15,0,0-.14c-.63-2.59-1.19-4.91-1.72-7.11l.22.17-12.1.15.16-.13c-.62,2.86-1.12,5.2-1.54,7.15V57l-.07,0a31.36,31.36,0,0,0-5.54,2.13l-1.3.68a3,3,0,0,1-.43.22,4.69,4.69,0,0,1,.4-.27c.28-.17.7-.43,1.28-.74a29.31,29.31,0,0,1,5.52-2.25l-.08.09c.39-2,.86-4.3,1.44-7.17l0-.13h.13l12.1-.27h.17l0,.17c.54,2.2,1.12,4.52,1.76,7.1l-.18-.18a29.93,29.93,0,0,1,7.42,2.89h-.28l6.1-4,.19-.12.17.15,8.72,8.39.18.17-.13.21c-1.23,2-2.48,4.12-3.78,6.26V70a30.17,30.17,0,0,1,3.19,7.31l-.25-.24,7.16,1.49.27,0v.28q.12,5.89.23,12.09v.29l-.27.06-7.1,1.75.26-.26a30.22,30.22,0,0,1-2.92,7.43v-.38l4,6.12.16.24-.21.21-8.4,8.71-.2.21-.26-.15L453,111.4h.38a29.83,29.83,0,0,1-7.32,3.18l.26-.28-1.49,7.16-.06.29h-.3l-12.1.2h-.29l-.07-.28c-.6-2.46-1.19-4.88-1.73-7.11l.26.27a30.7,30.7,0,0,1-7.43-2.93l.37,0-6.12,4-.23.15-.2-.19c-3-2.93-6-5.78-8.7-8.42l-.19-.19.14-.22,3.8-6.25v.34a30.25,30.25,0,0,1-3.16-7.32L409,94l-7.16-1.5-.23,0v-.23q-.11-6.37-.19-12.1v-.21l.2-.05,7.11-1.72-.17.17A29.77,29.77,0,0,1,411.52,71v.22l-4-6.13-.08-.13.11-.1L416,56.15l.07-.07.08.05,4.6,2.87,1.19.75A4.69,4.69,0,0,1,422.36,60Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.56,35.53a18.11,18.11,0,0,1,4.34-1.88l.89-4.28,7.24-.13,1,4.25a17.59,17.59,0,0,1,4.4,1.73l3.66-2.4,5.21,5-2.27,3.74A17.44,17.44,0,0,1,396,45.92l4.29.9.13,7.24-4.26,1a17.59,17.59,0,0,1-1.73,4.4l2.4,3.66-5,5.21L388,66.1A17.82,17.82,0,0,1,383.68,68l-.89,4.29-7.25.12-1-4.25a17.52,17.52,0,0,1-4.39-1.73l-3.66,2.4-5.21-5L363.5,60a18.21,18.21,0,0,1-1.88-4.33l-4.28-.89-.13-7.25,4.25-1a17.76,17.76,0,0,1,1.73-4.39l-2.4-3.66,5-5.22,3.74,2.27Zm3.87,9.65a7.77,7.77,0,1,0,11-.19A7.76,7.76,0,0,0,373.43,45.18Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.43,45.18a5.81,5.81,0,0,1,1.44-1.27,7.74,7.74,0,0,1,5.07-1.2,7.88,7.88,0,0,1,6.23,4.37,7.16,7.16,0,0,1,.71,2.18,7.36,7.36,0,0,1,0,2.39,7.92,7.92,0,0,1-6.55,6.8,7.74,7.74,0,0,1-2.4,0,7.95,7.95,0,0,1-5.44-3.31,7.79,7.79,0,0,1-1.34-3.4,7.71,7.71,0,0,1,1-5.11,6,6,0,0,1,1.22-1.49s-.47.51-1.07,1.58a7.63,7.63,0,0,0,3.57,10.72,7,7,0,0,0,2.1.58,6.62,6.62,0,0,0,2.26-.05,7.5,7.5,0,0,0,6.2-6.42,6.85,6.85,0,0,0,0-2.26,7.47,7.47,0,0,0-.65-2.07,7.68,7.68,0,0,0-2.63-3A7.51,7.51,0,0,0,379.91,43a7.79,7.79,0,0,0-5,1C373.92,44.7,373.46,45.22,373.43,45.18Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.56,35.53l-.24-.12-.71-.42-2.82-1.66.08,0-5,5.24,0-.14,2.41,3.65,0,.07,0,.07a18.16,18.16,0,0,0-1.7,4.37l0,.08-.08,0-4.25,1.06.12-.16c0,2.28.09,4.7.14,7.24l-.14-.17,4.29.89.11,0,0,.11a17.7,17.7,0,0,0,1.87,4.28l.06.1-.06.1-2.26,3.74,0-.24,5.22,5-.26,0,3.66-2.4.11-.07.11.06a17.6,17.6,0,0,0,4.34,1.7l.13,0,0,.13c.33,1.33.69,2.78,1.05,4.25l-.22-.16,7.24-.13-.21.17c.28-1.35.59-2.81.89-4.28l0-.14.13,0a17.92,17.92,0,0,0,4.27-1.86h0l.12-.07.12.07,3.74,2.27-.28,0c1.7-1.76,3.38-3.49,5-5.21l0,.28-2.4-3.66-.07-.12.06-.11a17.51,17.51,0,0,0,1.71-4.34l0-.13.12,0,4.25-1-.16.21q-.06-3.7-.12-7.24l.17.2-4.29-.9-.12,0,0-.12a17.71,17.71,0,0,0-1.85-4.29l-.07-.1.07-.1,2.27-3.73,0,.22c-1.83-1.77-3.56-3.44-5.2-5l.21,0-3.67,2.39-.08.06-.08,0A17.61,17.61,0,0,0,383,33.63l-.09,0,0-.08c-.37-1.55-.71-2.94-1-4.26l.13.1-7.24.09.1-.07c-.37,1.71-.67,3.11-.92,4.28v0h0A19,19,0,0,0,370.6,35l-.78.41a.93.93,0,0,1-.26.13l.25-.16c.16-.1.41-.26.76-.44a17.44,17.44,0,0,1,3.31-1.35l-.05.06c.23-1.17.51-2.58.86-4.3l0-.07h.08l7.24-.16h.1l0,.11c.33,1.31.67,2.7,1,4.25l-.1-.11a17.72,17.72,0,0,1,4.43,1.73h-.16L391,32.68l.12-.08.1.1,5.22,5,.1.1-.07.13-2.27,3.74v-.2a17.73,17.73,0,0,1,1.91,4.38l-.15-.14,4.29.89.16,0v.16c.05,2.36.09,4.77.14,7.25v.16l-.16.05-4.26,1,.16-.16a17.81,17.81,0,0,1-1.74,4.45v-.22L397,63l.09.14-.12.13-5,5.21-.12.13-.15-.09-3.75-2.27h.23a17.85,17.85,0,0,1-4.38,1.9l.16-.16c-.31,1.47-.61,2.93-.9,4.28l0,.18h-.18l-7.24.12h-.18l0-.17c-.36-1.47-.71-2.92-1-4.26l.16.16A18.35,18.35,0,0,1,370,66.6h.22L366.56,69l-.14.09L366.3,69c-1.8-1.75-3.57-3.45-5.2-5l-.12-.11.09-.13,2.27-3.74v.2a18,18,0,0,1-1.89-4.38l.14.13L357.3,55l-.14,0v-.14c0-2.54-.07-5-.11-7.24v-.13l.12,0,4.26-1-.11.11a17.74,17.74,0,0,1,1.76-4.43v.14l-2.38-3.67-.05-.08.06-.06c2.06-2.11,3.76-3.86,5.06-5.18l0,0,.05,0,2.76,1.72.7.45Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.65,
    y: 51.49,
    width: 130.91,
    height: 216.7,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.3,
    y: 51.49,
    width: 130.91,
    height: 216.7,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.87,
    y: 55.88,
    width: 119.77,
    height: 207.91,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.67,
    y: 82.9,
    width: 73.65,
    height: 153.88,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.67,182.32c-.17-14.37,12.76-28.4,27-30.41,6.79-1,14,.39,20.34-2.21,11.32-4.64,14.92-19.68,26.32-24.14l.52,111.22H68.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.87,419.62a19.31,19.31,0,0,1,4.76-2.07l1-4.71,7.95-.14,1.15,4.67a19.73,19.73,0,0,1,4.83,1.9l4-2.63,5.72,5.52-2.49,4.11a19.64,19.64,0,0,1,2.07,4.76l4.71,1,.14,8L385,441.12a19.89,19.89,0,0,1-1.9,4.83l2.63,4-5.52,5.72-4.12-2.49a19.31,19.31,0,0,1-4.76,2.07l-1,4.71-7.95.14-1.15-4.68a19.7,19.7,0,0,1-4.83-1.89l-4,2.63-5.72-5.53,2.49-4.11a19.31,19.31,0,0,1-2.07-4.76l-4.71-1-.14-7.95L347,431.7a19.73,19.73,0,0,1,1.9-4.83l-2.63-4,5.52-5.73,4.12,2.5Zm4.24,10.6a8.54,8.54,0,1,0,12.07-.21A8.53,8.53,0,0,0,360.11,430.22Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M470.8,466.91s.47,0,1.43,0l4.35,0V467c-22.5.11-114.13.2-223.68.2l-162.28-.08L41.45,467,28.08,467l-3.48,0-1.18,0,1.18,0,3.48,0,13.37-.05,49.17-.08,162.28-.08c109.55,0,201.18.09,223.68.2V467l-4.35,0C471.27,466.93,470.8,466.91,470.8,466.91Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Form--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 209.26,
    y: 78.37,
    width: 224.13,
    height: 316.25,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.39,394.62c0-2.11-.1-129.43-.24-316.25l.24.23-224.11,0h0l.26-.26c0,118.51,0,228.1-.05,316.25l-.21-.21,224.13.21-224.13.21H209v-.21c0-88.15,0-197.74,0-316.25V78.1h.28l224.11,0h.24v.24C433.49,265.19,433.39,392.51,433.39,394.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.35,
    y: 288.34,
    width: 95.68,
    height: 21.94,
    rx: 6.69,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.31,
    y: 288.34,
    width: 93.56,
    height: 21.94,
    rx: 6.69,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.9,
    y: 333.3,
    width: 197.29,
    height: 21.94,
    rx: 6.69,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.28,279.51c0,.14-9.24.26-20.65.26s-20.65-.12-20.65-.26,9.24-.26,20.65-.26S268.28,279.37,268.28,279.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,279.51c0,.14-7.28.26-16.26.26s-16.27-.12-16.27-.26,7.28-.26,16.27-.26S366,279.37,366,279.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.5,324.25c0,.14-15,.26-33.5.26s-33.5-.12-33.5-.26,15-.26,33.5-.26S294.5,324.11,294.5,324.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.38,
    y: 238.53,
    width: 200.81,
    height: 23.98,
    rx: 6.51,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.56,250.52c0,.15-17.82.26-39.79.26s-39.8-.11-39.8-.26,17.82-.26,39.8-.26S363.56,250.38,363.56,250.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.38,
    y: 92.73,
    width: 200.81,
    height: 23.98,
    rx: 6.51,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.56,104.72c0,.14-17.82.26-39.79.26s-39.8-.12-39.8-.26,17.82-.26,39.8-.26S363.56,104.57,363.56,104.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.39,122.51c0,.15-50.22.27-112.16.27s-112.18-.12-112.18-.27,50.22-.26,112.18-.26S433.39,122.37,433.39,122.51Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.39,228.6c0,.15-50.22.26-112.16.26s-112.18-.11-112.18-.26,50.22-.26,112.18-.26S433.39,228.46,433.39,228.6Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.35,
    y: 146.56,
    width: 95.68,
    height: 21.94,
    rx: 6.69,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.31,
    y: 146.56,
    width: 93.56,
    height: 21.94,
    rx: 6.69,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.9,
    y: 191.52,
    width: 197.29,
    height: 21.94,
    rx: 6.69,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.28,137.73c0,.14-9.24.26-20.65.26s-20.65-.12-20.65-.26,9.24-.26,20.65-.26S268.28,137.59,268.28,137.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,137.73c0,.14-7.28.26-16.26.26s-16.27-.12-16.27-.26,7.28-.26,16.27-.26S366,137.59,366,137.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.5,182.47c0,.14-15,.26-33.5.26s-33.5-.12-33.5-.26,15-.26,33.5-.26S294.5,182.33,294.5,182.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.27,368.57c0,.15-14.63.26-32.68.26s-32.67-.11-32.67-.26,14.62-.26,32.67-.26S414.27,368.43,414.27,368.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.34,159.83a11.27,11.27,0,0,1-1.55.39,18.33,18.33,0,0,1-11.55-1.65,6.46,6.46,0,0,1-1.77-1.35,4.16,4.16,0,0,1-1.07-2.13,3.14,3.14,0,0,1,.51-2.48,2.4,2.4,0,0,1,2.53-.8,1.8,1.8,0,0,1,1.11.93,2.31,2.31,0,0,1,.19,1.46,5.26,5.26,0,0,1-1.38,2.57,12.67,12.67,0,0,1-5,3.43,12.11,12.11,0,0,1-6.48.58,7.15,7.15,0,0,1-3.17-1.39,3.77,3.77,0,0,1-1.54-3.2,3.48,3.48,0,0,1,.69-1.75,2.78,2.78,0,0,1,1.58-1.1,2,2,0,0,1,1.87.62,2.81,2.81,0,0,1,.67,1.85,3.87,3.87,0,0,1-.46,1.9,4.33,4.33,0,0,1-1.36,1.43,12.15,12.15,0,0,1-3.58,1.43c-2.43.69-5.08,1.44-7.78.83a7.29,7.29,0,0,1-3.58-1.94,5.15,5.15,0,0,1-1.56-3.83,3.43,3.43,0,0,1,1.09-2.43,2.49,2.49,0,0,1,2.64-.28,2,2,0,0,1,1.11,2.35,3.9,3.9,0,0,1-1.56,2.07,20.42,20.42,0,0,1-9,3.42,9.23,9.23,0,0,1-4.69-.41,4.73,4.73,0,0,1-2.88-3.54,3.21,3.21,0,0,1,2.38-3.59,2.24,2.24,0,0,1,2.14.76,3.46,3.46,0,0,1,.75,2.08,4.18,4.18,0,0,1-.46,2.11,4.92,4.92,0,0,1-1.42,1.55,11,11,0,0,1-3.67,1.54c-2.45.65-5,1.11-7.32.26a6.26,6.26,0,0,1-2.78-2,4.58,4.58,0,0,1-1-3.09,4.32,4.32,0,0,1,1.34-2.71,2.93,2.93,0,0,1,2.67-.8l.1,0v.1a7.75,7.75,0,0,1-2,5.32,8.07,8.07,0,0,1-3.51,2.39,6.53,6.53,0,0,1-2.62.34c-.6-.09-.9-.17-.9-.17a6.94,6.94,0,0,0,3.47-.32,8,8,0,0,0,3.39-2.38,7.57,7.57,0,0,0,1.84-5.16l.11.13a2.68,2.68,0,0,0-2.39.75,4,4,0,0,0-1.21,2.51c-.15,2,1.46,4,3.56,4.72s4.65.35,7.08-.31a10.62,10.62,0,0,0,3.52-1.49,4.51,4.51,0,0,0,1.28-1.4,3.67,3.67,0,0,0,.4-1.88,3,3,0,0,0-.64-1.79,1.77,1.77,0,0,0-1.7-.61,2.75,2.75,0,0,0-2,3.07,4.24,4.24,0,0,0,2.59,3.14,8.73,8.73,0,0,0,4.44.37,19.84,19.84,0,0,0,8.75-3.34,3.47,3.47,0,0,0,1.37-1.77,1.49,1.49,0,0,0-.84-1.76,2,2,0,0,0-2.07.21,2.9,2.9,0,0,0-.91,2.06,4.63,4.63,0,0,0,1.41,3.43,6.78,6.78,0,0,0,3.32,1.8c2.52.58,5.11-.12,7.53-.81a11.94,11.94,0,0,0,3.43-1.36,3.8,3.8,0,0,0,1.21-1.25,3.41,3.41,0,0,0,.4-1.65,2.32,2.32,0,0,0-.54-1.53,1.48,1.48,0,0,0-1.4-.47,2.81,2.81,0,0,0-1.89,2.42A3.31,3.31,0,0,0,278,159a6.83,6.83,0,0,0,3,1.31,11.73,11.73,0,0,0,6.24-.55,12.1,12.1,0,0,0,4.87-3.29,4.91,4.91,0,0,0,1.3-2.36,1.64,1.64,0,0,0-1-2,2,2,0,0,0-2.14.67,2.82,2.82,0,0,0-.47,2.2,4.78,4.78,0,0,0,2.66,3.28,18.25,18.25,0,0,0,6.85,2,19.66,19.66,0,0,0,4.54-.16l1.17-.22A2.67,2.67,0,0,1,305.34,159.83Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.17,158.64a6.7,6.7,0,0,1-1.26.62,11.23,11.23,0,0,1-3.94.83,12.12,12.12,0,0,1-6.18-1.44,7.68,7.68,0,0,1-3-2.65,3.49,3.49,0,0,1-.54-2.17,3,3,0,0,1,1.16-2.06,1.9,1.9,0,0,1,1.22-.4,1.84,1.84,0,0,1,1.21.51,3,3,0,0,1,.81,2.47,4.37,4.37,0,0,1-1.26,2.37,10.18,10.18,0,0,1-2.18,1.67,13,13,0,0,1-5.47,1.75,10.41,10.41,0,0,1-6-1.11,5.94,5.94,0,0,1-2.32-2.24,4.51,4.51,0,0,1-.53-1.6,4.1,4.1,0,0,1,2.63-4.09,2.31,2.31,0,0,1,1.8.18,2.79,2.79,0,0,1,1.2,1.34,4.15,4.15,0,0,1-.13,3.51,7.3,7.3,0,0,1-2.38,2.62,13.19,13.19,0,0,1-13.66.82,10.38,10.38,0,0,1-2.82-2.1,4.76,4.76,0,0,1-1.4-3.21,3.17,3.17,0,0,1,1.92-2.85,1.92,1.92,0,0,1,1.8.21,2.6,2.6,0,0,1,1,1.46,3.79,3.79,0,0,1-.67,3.24,10.11,10.11,0,0,1-2.31,2.22A14.08,14.08,0,0,1,350.6,161a7.57,7.57,0,0,1-4.58-2.74,4.21,4.21,0,0,1-.85-2.43,4.58,4.58,0,0,1,.6-2.4,3,3,0,0,1,1.85-1.47,2.61,2.61,0,0,1,2.18.49,4,4,0,0,1,1.48,3.67,4.93,4.93,0,0,1-1.77,3,6.52,6.52,0,0,1-2.61,1.32,12.68,12.68,0,0,1-4,.25l-1-.09a1.41,1.41,0,0,1-.35,0,1.55,1.55,0,0,1,.35,0l1.05,0a13.52,13.52,0,0,0,4-.34,6.46,6.46,0,0,0,2.5-1.32A4.67,4.67,0,0,0,351,156a3.73,3.73,0,0,0-1.38-3.36,2.32,2.32,0,0,0-1.91-.41,2.71,2.71,0,0,0-1.61,1.32,4,4,0,0,0,.25,4.4,7.24,7.24,0,0,0,4.35,2.56,13.64,13.64,0,0,0,10.92-2.38A9.75,9.75,0,0,0,363.8,156a3.28,3.28,0,0,0,.59-2.82,2.08,2.08,0,0,0-.79-1.18,1.42,1.42,0,0,0-1.34-.16,2.67,2.67,0,0,0-1.59,2.39,4.29,4.29,0,0,0,1.27,2.85,10.09,10.09,0,0,0,2.69,2,12.91,12.91,0,0,0,6.67,1.43,12.53,12.53,0,0,0,6.44-2.23A6.75,6.75,0,0,0,380,155.9a3.67,3.67,0,0,0,.13-3.07,2,2,0,0,0-2.4-1.25,3.61,3.61,0,0,0-2.28,3.56,3.92,3.92,0,0,0,.47,1.41,5.41,5.41,0,0,0,2.13,2.06,9.94,9.94,0,0,0,5.69,1.08A12.61,12.61,0,0,0,389,158a9.79,9.79,0,0,0,2.1-1.58,4,4,0,0,0,1.16-2.14,2.6,2.6,0,0,0-.68-2.14,1.48,1.48,0,0,0-1.95-.09,2.69,2.69,0,0,0-1,1.8,3.31,3.31,0,0,0,.48,2,7.51,7.51,0,0,0,2.87,2.55,11.91,11.91,0,0,0,6,1.5,12.12,12.12,0,0,0,3.9-.72C402.74,158.86,403.15,158.61,403.17,158.64Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.2,202.81a2,2,0,0,1-.38.19l-1.15.52c-1,.45-2.51,1.11-4.48,1.85a36.6,36.6,0,0,1-7.42,2,28.34,28.34,0,0,1-4.8.29,16.16,16.16,0,0,1-5.34-.8,6.37,6.37,0,0,1-4.06-4.23,4.17,4.17,0,0,1,.4-3.19,3.6,3.6,0,0,1,2.76-1.86,3.07,3.07,0,0,1,2.87,1.85,4.72,4.72,0,0,1,.25,3.56,7,7,0,0,1-2.09,3,13.7,13.7,0,0,1-3.14,2,10.77,10.77,0,0,1-7.59.89,7.71,7.71,0,0,1-5.28-5.82,6.23,6.23,0,0,1,0-2.11,4,4,0,0,1,.86-2,2.67,2.67,0,0,1,1.92-1.11,1.92,1.92,0,0,1,1.85,1.29,5.15,5.15,0,0,1-.74,4.25,12.88,12.88,0,0,1-2.8,3.32,11.84,11.84,0,0,1-15.67-.24,6.67,6.67,0,0,1-2-3.58,4.09,4.09,0,0,1,.13-2.08,4.26,4.26,0,0,1,1.17-1.71,3.42,3.42,0,0,1,1.87-.87,2.46,2.46,0,0,1,2,.61,3.81,3.81,0,0,1,.89,3.75,7,7,0,0,1-2.07,3.14,16.68,16.68,0,0,1-2.91,2.17,16.85,16.85,0,0,1-6.53,2.22,14.79,14.79,0,0,1-6.42-.57,7.1,7.1,0,0,1-2.64-1.59,4.93,4.93,0,0,1-1.43-2.58,4.5,4.5,0,0,1,.26-2.81,2.76,2.76,0,0,1,2.1-1.63,3.11,3.11,0,0,1,2.44.67,2.28,2.28,0,0,1,.77,2.22,3.47,3.47,0,0,1-1.15,1.89,7.62,7.62,0,0,1-1.69,1.12,18.74,18.74,0,0,1-3.29,1.26,18.41,18.41,0,0,1-4.8.71,11,11,0,0,1-1.69-.07h.43c.29,0,.71,0,1.26,0a19.73,19.73,0,0,0,4.74-.8,20,20,0,0,0,3.24-1.29,7.25,7.25,0,0,0,1.62-1.1,3.23,3.23,0,0,0,1-1.74,2,2,0,0,0-.69-1.94,2.86,2.86,0,0,0-2.19-.58,2.42,2.42,0,0,0-1.83,1.46,4.12,4.12,0,0,0-.22,2.58,5.45,5.45,0,0,0,3.84,3.87,14.21,14.21,0,0,0,6.23.52,16.4,16.4,0,0,0,9.17-4.3,6.49,6.49,0,0,0,1.94-2.93,3.33,3.33,0,0,0-.76-3.26,2.37,2.37,0,0,0-3.18.28,3.77,3.77,0,0,0-1,1.49,3.64,3.64,0,0,0-.11,1.83,6.22,6.22,0,0,0,1.89,3.3,11.34,11.34,0,0,0,15,.21,12.06,12.06,0,0,0,2.69-3.19,5.74,5.74,0,0,0,.77-1.87,3.5,3.5,0,0,0-.06-1.93,1.44,1.44,0,0,0-1.35-1,2.21,2.21,0,0,0-1.54.92,4.63,4.63,0,0,0-.75,3.68,7.22,7.22,0,0,0,4.92,5.43,10.3,10.3,0,0,0,7.24-.84c2.18-1.05,4.27-2.57,5-4.74a4.27,4.27,0,0,0-.22-3.22,2.62,2.62,0,0,0-2.44-1.62,3.19,3.19,0,0,0-2.43,1.64,3.73,3.73,0,0,0-.37,2.88,6,6,0,0,0,3.8,4,15.75,15.75,0,0,0,5.22.82,27.94,27.94,0,0,0,4.75-.25,37.14,37.14,0,0,0,7.39-1.87c2-.71,3.48-1.34,4.51-1.75l1.17-.48Z",
    style: {
      fill: "#90CAF9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405,422.83s-23-26.48-31.7-53-4.55-23.44-4.55-23.44,11.72,25.72,20.62,38.15,24.75,30.66,24.75,30.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.62,350.54a1.34,1.34,0,0,0-2.49.85c1.4,9.31,4.43,31.14,4.32,45.3-.16,18.39,0,25.5,0,25.5H421s-1.7-38-3.87-49.62C415.65,364.45,412.43,355.42,409.62,350.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.85,419.1a101.62,101.62,0,0,0,7.88-28.59c.79-6.78-.62-15.93-2.71-28.14a74.43,74.43,0,0,1-1.21-13.53,2.28,2.28,0,0,1,4.29-1.07c1.15,2.06,4.5,9.1,5.35,13.52,2.32,12.06,4.94,18.09,2.94,29.52S422,419.87,422,419.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.47,419.87s25.27-54.29,27-62.35,7.7-26.61,8.4-25.56,1.76,10.85-2.8,22.06-24,67.51-24,67.51h-8.63",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.08,417.44a4.87,4.87,0,0,1-.71-.48c-.45-.34-1.13-.82-2-1.5a90.27,90.27,0,0,1-6.79-6,114.41,114.41,0,0,1-18.33-23.53,154.54,154.54,0,0,1-12.51-27.1c-1.27-3.61-2.19-6.56-2.8-8.61-.3-1-.52-1.82-.67-2.37a5.15,5.15,0,0,1-.19-.83,4.64,4.64,0,0,1,.3.8l.76,2.34c.67,2,1.65,5,3,8.54a164.11,164.11,0,0,0,12.62,27,119.09,119.09,0,0,0,18.13,23.53c2.71,2.69,5,4.73,6.66,6.1.8.7,1.46,1.2,1.89,1.57A6,6,0,0,1,412.08,417.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.84,391.4a11,11,0,0,1-.22-1.6l-.47-4.35c-.4-3.67-1-8.74-1.92-14.3s-1.89-10.58-2.66-14.19l-.92-4.28a8.11,8.11,0,0,1-.28-1.58,10.85,10.85,0,0,1,.48,1.53c.29,1,.66,2.45,1.09,4.25.87,3.6,1.93,8.6,2.83,14.18s1.46,10.67,1.76,14.35c.15,1.85.25,3.34.3,4.38A9.1,9.1,0,0,1,414.84,391.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.76,347.34a3.52,3.52,0,0,1,.3.69c.19.51.44,1.18.76,2s.72,1.95,1.08,3.23.86,2.71,1.23,4.35l.63,2.55c.21.89.36,1.83.55,2.79.41,1.93.67,4,1,6.22a93,93,0,0,1-1,28.7c-.47,2.16-.87,4.23-1.42,6.12-.26.95-.48,1.88-.75,2.75s-.55,1.71-.81,2.5c-.48,1.61-1.07,3-1.54,4.25s-.91,2.3-1.31,3.15l-.9,2a3.31,3.31,0,0,1-.35.66,5.4,5.4,0,0,1,.25-.71c.21-.5.47-1.17.81-2s.79-1.92,1.22-3.17,1-2.66,1.46-4.26c.24-.8.5-1.64.77-2.5s.47-1.8.72-2.75c.53-1.89.91-3.95,1.36-6.1a95.88,95.88,0,0,0,1-28.56c-.29-2.18-.53-4.26-.92-6.18-.18-1-.32-1.9-.52-2.79s-.4-1.74-.59-2.55c-.34-1.64-.8-3.08-1.15-4.35s-.69-2.37-1-3.26l-.66-2A3.46,3.46,0,0,1,420.76,347.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.61,333.05a2.18,2.18,0,0,1,0,.24c0,.19-.07.42-.12.71-.11.61-.25,1.53-.5,2.7-.48,2.34-1.3,5.7-2.56,9.77s-3,8.87-5,14.12-4.41,11-6.65,17.08-4,12-5.68,17.42-3.19,10.23-4.68,14.23a92.56,92.56,0,0,1-4,9.29c-.52,1.07-1,1.87-1.29,2.43l-.35.62a.93.93,0,0,1-.14.2l.09-.23c.09-.17.19-.39.31-.65.27-.56.7-1.38,1.19-2.47,1-2.15,2.38-5.31,3.82-9.32s3-8.85,4.56-14.25,3.37-11.35,5.65-17.46,4.63-11.83,6.7-17.07,3.83-10,5.13-14.05,2.17-7.39,2.72-9.71c.28-1.15.45-2.06.6-2.67.06-.28.12-.51.16-.7A.74.74,0,0,1,458.61,333.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.7,321.05a2.18,2.18,0,0,0-3.58,2.22,61.51,61.51,0,0,0,3.17,8.17c3.47,7.38,13.68,33.86,18.45,48.41s11.51,41.68,11.51,41.68l10.2-1.66s-9.33-44.58-18.45-60.65C394.67,346.32,387.35,327.66,380.7,321.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.53,388.94a5.69,5.69,0,0,1,.53,1.23c.3.8.71,2,1.18,3.42.94,2.91,2.08,7,3.24,11.49s2.12,8.62,2.79,11.6c.31,1.41.56,2.59.77,3.53a6,6,0,0,1,.21,1.32,6.22,6.22,0,0,1-.42-1.27c-.24-.93-.56-2.1-.93-3.49-.78-3.07-1.81-7.1-2.94-11.56s-2.25-8.58-3.09-11.51l-1-3.47A7,7,0,0,1,401.53,388.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.37,420.7a1,1,0,0,1-.06-.27c0-.21-.06-.48-.11-.81-.11-.7-.2-1.75-.42-3.08-.37-2.68-1-6.54-2.14-11.25a160.72,160.72,0,0,0-4.77-16.3c-2.09-6-4.72-12.57-7.69-19.32-6-13.5-12-25.47-15.93-34.33-2-4.41-3.53-8-4.55-10.53-.52-1.25-.89-2.23-1.15-2.9-.11-.31-.2-.56-.28-.76a1,1,0,0,1-.08-.27,1.24,1.24,0,0,1,.13.25l.33.74c.3.69.72,1.65,1.24,2.86,1.08,2.49,2.67,6.06,4.7,10.46,4,8.8,10.07,20.74,16.08,34.26,3,6.77,5.6,13.31,7.67,19.38A154.72,154.72,0,0,1,413,405.2a114.24,114.24,0,0,1,2,11.31c.18,1.34.25,2.39.32,3.1q0,.5.06.81A1,1,0,0,1,415.37,420.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.45,419.87a10,10,0,0,1-.35-1.71c-.2-1.2-.47-2.78-.79-4.69-.7-4-1.78-9.39-3.32-15.32s-3.25-11.2-4.57-15l-1.6-4.48a11.5,11.5,0,0,1-.54-1.66,9.85,9.85,0,0,1,.74,1.59c.44,1,1.05,2.54,1.76,4.42a147.21,147.21,0,0,1,4.73,15,155.63,155.63,0,0,1,3.18,15.39c.29,2,.51,3.6.62,4.72A13,13,0,0,1,420.45,419.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.57,
    y: 418.41,
    width: 39.81,
    height: 48.5,
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 401.57,
    y: 418.41,
    width: 39.81,
    height: 48.5
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 393.36,
    y: 418.41,
    width: 35.32,
    height: 48.5,
    style: {
      fill: "#90CAF9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.18,161.26l-1.13,91.12c-.19,15.49,2.69,38.29,27.2,37.48h0c21.22-2.31,26.85-22.39,27-36.85.08-6.86.16-12.58.21-13.28,0,0,23.22-1.9,25.18-24.84.95-11.08,1-34.07.89-54.87a42.87,42.87,0,0,0-39.77-42.41l-2.22-.17C118.56,117.1,104.87,137.27,105.18,161.26Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.47,239.73s-14.53-.21-29.24-11c0,0,6.06,17.3,29.12,16.9Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.32,169.42c-.45.47-3.1-1.67-6.95-1.77s-6.71,1.78-7.11,1.29c-.2-.22.27-1.07,1.53-1.95a9.6,9.6,0,0,1,5.71-1.62,9.24,9.24,0,0,1,5.51,2C145.17,168.34,145.55,169.22,145.32,169.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.21,177.37a3.12,3.12,0,0,1-3.22,2.91,3,3,0,0,1-3-3,3.11,3.11,0,0,1,3.21-2.91A3,3,0,0,1,145.21,177.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155,196.15c0-.2,2.22-.42,5.8-.61.91,0,1.78-.15,2-.75a4.58,4.58,0,0,0-.4-2.71L160.15,185c-3-10-5.07-18.26-4.67-18.38s3.16,7.93,6.14,18c.72,2.48,1.4,4.83,2,7.09.27,1.05.77,2.25.21,3.57a2.25,2.25,0,0,1-1.58,1.21,6.1,6.1,0,0,1-1.54.1C157.17,196.5,155,196.36,155,196.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.69,155c-.37.86-3.45.21-7.13.4s-6.72,1-7.14.19c-.19-.4.38-1.18,1.63-1.94a11.61,11.61,0,0,1,5.4-1.52,11.37,11.37,0,0,1,5.47,1.08C143.22,153.83,143.85,154.57,143.69,155Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.18,162.09c-.4.7-3.4-.07-7-.18s-6.65.35-7-.38c-.16-.34.44-1,1.7-1.52a12.84,12.84,0,0,1,5.38-.89,13.11,13.11,0,0,1,5.34,1.32C179.78,161.09,180.36,161.76,180.18,162.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.82,178.4c-.38-.2-15.44-5.82-16.08,9.91S105,201.45,105.07,201,105.82,178.4,105.82,178.4Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.51,194.84c-.07-.05-.29.18-.76.37a2.73,2.73,0,0,1-2,0c-1.64-.68-2.93-3.37-2.89-6.21a9.07,9.07,0,0,1,.93-3.89,3.14,3.14,0,0,1,2.15-2,1.38,1.38,0,0,1,1.58.81c.2.45.08.76.17.79s.35-.25.24-.9a1.72,1.72,0,0,0-.57-1,2.1,2.1,0,0,0-1.5-.47,3.88,3.88,0,0,0-3,2.33,9.46,9.46,0,0,0-1.13,4.34c0,3.18,1.48,6.21,3.72,7a3,3,0,0,0,2.53-.31C100.46,195.22,100.56,194.87,100.51,194.84Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.24,207.05c.17-.4-2.91-1.32-5.08-4.22a17.8,17.8,0,0,1-2.18-4.1c-.46-1.15-.81-1.86-1-1.81s-.13.82.13,2.07a11.71,11.71,0,0,0,2,4.6,9.36,9.36,0,0,0,4,3.07C150.38,207.15,151.19,207.18,151.24,207.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.36,170.87c-.46.46-3.11-1.67-7-1.77s-6.71,1.78-7.12,1.29c-.2-.22.28-1.07,1.53-1.95a9.6,9.6,0,0,1,5.71-1.62,9.27,9.27,0,0,1,5.52,2C180.2,169.79,180.58,170.66,180.36,170.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.73,178.49a3.12,3.12,0,0,1-3.22,2.91,3,3,0,0,1-3-3,3.12,3.12,0,0,1,3.22-2.91A3,3,0,0,1,179.73,178.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.54,129.56a12.42,12.42,0,0,0-15.48-4.9A17,17,0,0,0,155.79,110a6.92,6.92,0,0,0-3.39-4.65,13.65,13.65,0,0,0-5.64-1.69,27,27,0,0,0-24.67,10.76,29.39,29.39,0,0,0-24.91,9.09c-7.39,8.19-8.79,27.16-.69,43.55l1.9,10.27c2.54,0,4.86.18,6.43,1.58,2.13,1.91,3.08,5.51,6.61,4.15,1.8-.7,3.44-4.47,4-6.3a89.66,89.66,0,0,0,3.88-37.9,28.73,28.73,0,0,1,8.88-6.41l-.27.25c6.41-2.23,13.66-4.42,19.74-1.41,4.72,2.33,7.5,7.23,11,11.13a36,36,0,0,0,25.67,11.86c.34,6.46-.2,15.59.14,22L190,166V166a24.62,24.62,0,0,0,1.17-2.28l.12-.24v0h0c1-.81,1.74-2.29,3.42-4.21a13.54,13.54,0,0,0,2.23-13.87A12.41,12.41,0,0,0,200.54,129.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.13,159.86l0,0h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.13,129.8s.06.11.12.34a4.87,4.87,0,0,1,.14,1,6.81,6.81,0,0,1-.91,3.68,7.21,7.21,0,0,1-1.76,2,6.27,6.27,0,0,1-2.87,1.22,7.1,7.1,0,0,1-6.56-2.47l.39-.33a4.26,4.26,0,0,1,1.11,3.08,5.63,5.63,0,0,1-1.76,4,6.38,6.38,0,0,1-3.72,1.59,10,10,0,0,1-6.46-1.78,21.07,21.07,0,0,1-3.46-2.94,10,10,0,0,1-1.1-1.24,11.16,11.16,0,0,1,1.24,1.1,24.8,24.8,0,0,0,3.52,2.77,9.74,9.74,0,0,0,6.21,1.61,6,6,0,0,0,3.43-1.48,5.19,5.19,0,0,0,1.58-3.6,3.82,3.82,0,0,0-1-2.72l.39-.34a6.67,6.67,0,0,0,6.08,2.34,6.14,6.14,0,0,0,4.4-3,7,7,0,0,0,1-3.51C191.22,130.28,191.09,129.81,191.13,129.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.45,112.56s.12,0,.34.15a7.47,7.47,0,0,1,.87.59,7.69,7.69,0,0,1,2.38,3.08,6.06,6.06,0,0,1-.54,5.67,4.68,4.68,0,0,1-2.87,2,4.75,4.75,0,0,1-3.67-.71,4.48,4.48,0,0,1-.87-.87l.45-.26a4.39,4.39,0,0,1-.12,3.54,4.77,4.77,0,0,1-2.28,2.34,6.36,6.36,0,0,1-5.36,0,8.61,8.61,0,0,1-2.89-2.17,4.27,4.27,0,0,1-.77-1.08s.32.35.91.94a9.19,9.19,0,0,0,2.89,2,6.09,6.09,0,0,0,5-.09,4.41,4.41,0,0,0,2-2.13,3.93,3.93,0,0,0,.1-3.12l-.84-1.93,1.29,1.68a3.51,3.51,0,0,0,.75.74,4.22,4.22,0,0,0,3.26.64,4.17,4.17,0,0,0,2.57-1.74,5.7,5.7,0,0,0,.59-5.26,7.94,7.94,0,0,0-2.16-3.06C171.86,112.85,171.42,112.6,171.45,112.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305,227.26,268.65,255a4.71,4.71,0,0,0-.69,6.82h0a4.69,4.69,0,0,0,6.43.63l36-28,4.87-9.61Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.6,225.93l2.57,3-2.78,5.52a2.21,2.21,0,0,1-2.42-2.51,2,2,0,0,1-2.2-2.52s-1.89-.17-.82-2.16Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.65 254.97 274.61 262.25 276.61 260.7 270.9 253.26 268.65 254.97",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,324.46l-1.31-.24,26.74-46.74L287.19,264s-4.9-19.19-.82-24.09c0,0,8.93-10.52,11.83-10.37s5.21.72,5.79,2.9c0,0,4.93-.58,6.23,1a24.93,24.93,0,0,1,2.32,3.48s5.36-.44,6.81,4.2c0,0,5.07,2.61,5.51,6.37s-1,21.3-2.61,25.79-7.54,13.91-9.27,27.82-7.87,22.94-13.32,43.26l-14.79,5.85Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.74,232.14c.11.15-1.73,1.37-3.12,3.62s-1.72,4.41-1.91,4.38a9.06,9.06,0,0,1,5-8Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.25,236.92c.1.16-1.66,1.22-3.05,3.24s-1.83,4-2,4,0-2.19,1.51-4.32A7,7,0,0,1,312.25,236.92Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.07,241c.11.14-1.22,1.31-2.44,3.07s-1.88,3.41-2.05,3.35a7.1,7.1,0,0,1,1.55-3.69A7,7,0,0,1,319.07,241Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294,242.52a10.42,10.42,0,0,0-3-.51,10,10,0,0,0-2.88.91c-.05,0,.14-.38.63-.74a4.38,4.38,0,0,1,4.49-.3C293.76,242.17,294,242.46,294,242.52Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.62,249.19a12,12,0,0,0-2.21-2.64c-1.51-1.18-3.15-1.25-3.13-1.43s.41-.17,1.08-.09a5.32,5.32,0,0,1,4.05,3.09C304.67,248.75,304.69,249.17,304.62,249.19Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.21,251.45c-.13.13-1.3-1.19-3.29-1.71a13.14,13.14,0,0,0-3.7-.18c0-.07.35-.31,1.06-.48a6,6,0,0,1,5.26,1.42C315.06,251,315.26,251.41,315.21,251.45Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.41,302.44S29,395.52,29.81,404.23s5.15,22.55,15,24.92a43.55,43.55,0,0,0,19,0L52,314.82Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4,254.42s-19.62,14-24,18.05c-18.14,17.15-21.93,24.17-24,30S58,443,58,443l3,23.55h0l137.67.35h0V346.61L178,261.94l-12.73-3.62-2.57-10.09s-15.81-11.68-41.89-12c-8-.11-19.38,3.05-25.72,8h0Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.56,262.29s14.15-.63,15.4-.35c4.36,1,16.33,12,30,25.52,13,12.9,38.62,39.75,38.62,39.75s4.6-4.64,9.85,1.56l20.21-29.4S307,303.09,311.72,326c0,0-9.3,17.76-16.92,30.45,0,0-28.19,46.79-50.46,38.31C224,387,198.49,366.32,194.9,361.9l-30-21.37s-20.52-39.12-11.45-58.68Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.23,258.32a3.19,3.19,0,0,1-.72-.15l-2-.54c-1.77-.45-4.35-1.07-7.57-1.68a212.56,212.56,0,0,0-25.41-3.13,173,173,0,0,0-25.59.08c-3.27.28-5.89.69-7.69,1l-2.07.41a2.54,2.54,0,0,1-.73.1,3.46,3.46,0,0,1,.7-.22l2.05-.52a68.76,68.76,0,0,1,7.7-1.21,157.38,157.38,0,0,1,25.67-.25A188.22,188.22,0,0,1,155,255.53c3.22.67,5.79,1.35,7.56,1.88l2,.65A3.12,3.12,0,0,1,165.23,258.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.61,251.32c-.17,0-.62-2.28-1-5.15s-.59-5.2-.42-5.23a23.49,23.49,0,0,1,1,5.15C111.59,249,111.78,251.3,111.61,251.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.75,250.88a16.43,16.43,0,0,1-.72-10.42c.18,0-.09,2.36.11,5.23S116.92,250.83,116.75,250.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.85,254.31c21.54,3.81,43.38,0,66.18,2.73-22-4.56-44.94-6.72-66.18-2.73"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56,429.33c-12.12-28.39-10.68-60.47-9-91.28Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M45.41,322.73a1.71,1.71,0,0,1,.06.36c0,.27.08.62.13,1.05.1,1,.25,2.33.43,4.07.35,3.57.86,8.67,1.48,15,1.23,12.62,2.91,30.07,4.92,49.32s4,36.66,5.62,49.24c.79,6.29,1.47,11.38,2,14.89.23,1.73.41,3.09.53,4.05.06.44.1.79.13,1.06a2,2,0,0,1,0,.36,1.5,1.5,0,0,1-.08-.35l-.19-1.05c-.15-1-.37-2.31-.64-4-.55-3.51-1.3-8.59-2.15-14.87-1.71-12.57-3.79-30-5.8-49.24s-3.62-36.71-4.74-49.34c-.54-6.29-1-11.4-1.29-15-.13-1.74-.24-3.1-.31-4.07,0-.44,0-.79-.07-1.07A1.67,1.67,0,0,1,45.41,322.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.61,307.5a4.59,4.59,0,0,1-.88.05l-2.55,0c-2.2,0-5.4,0-9.34.11-7.89.18-18.78.76-30.73,2.17S72.43,313.28,64.72,315c-3.86.83-7,1.55-9.11,2.08l-2.48.58a5.26,5.26,0,0,1-.87.16,4.91,4.91,0,0,1,.84-.28l2.45-.69c2.13-.6,5.23-1.38,9.08-2.27a287.57,287.57,0,0,1,61.2-7.29c4,0,7.15,0,9.36.08l2.54.1A5.48,5.48,0,0,1,138.61,307.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.75,337.64c-.17,0,.15-12.89.7-28.78s1.15-28.78,1.32-28.77-.15,12.89-.71,28.79S85.91,337.65,85.75,337.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.1,336.05a7.52,7.52,0,0,1-.51-.81q-.53-.89-1.38-2.37l-5.08-8.73a75.15,75.15,0,0,1-6.37-13.57,44.19,44.19,0,0,1-1.9-8.68,52.35,52.35,0,0,1,0-9.54,50.78,50.78,0,0,1,4.54-17.77,29.63,29.63,0,0,1,4.49-6.69,25.51,25.51,0,0,1,5.38-4.49,20.51,20.51,0,0,1,9.55-3.2,13.28,13.28,0,0,1,3.7.21,34.52,34.52,0,0,0-3.68,0,20.76,20.76,0,0,0-9.34,3.32,25.4,25.4,0,0,0-5.24,4.47,29.28,29.28,0,0,0-4.35,6.6,50.83,50.83,0,0,0-4.45,17.58,52.76,52.76,0,0,0,0,9.41,44.69,44.69,0,0,0,1.84,8.57,78.19,78.19,0,0,0,6.21,13.54l4.91,8.82,1.29,2.43A5.44,5.44,0,0,1,156.1,336.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.49,317.71a164.67,164.67,0,0,0,25.87-3.41,39.63,39.63,0,0,0-1.45,11.57,26.6,26.6,0,0,0,5.75-10.59A16,16,0,0,0,91.19,326a35.12,35.12,0,0,0,.58-11.79q19.31-2.32,38.36-6.35A260.16,260.16,0,0,0,54,317.33"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M220,381.87a2.73,2.73,0,0,1-.59-.35l-1.65-1.1c-1.42-1-3.46-2.37-6-4.14-5-3.52-11.91-8.47-19.42-14.07s-14.22-10.8-19-14.61c-2.4-1.9-4.34-3.46-5.67-4.55l-1.52-1.26a3.22,3.22,0,0,1-.51-.47,4,4,0,0,1,.58.39l1.58,1.18,5.77,4.42c4.87,3.74,11.61,8.88,19.12,14.48S207,372.38,212,376l5.88,4.28,1.59,1.17A4.17,4.17,0,0,1,220,381.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.59,351.19c-.09,0,0-1.52-.21-3.93a41.24,41.24,0,0,0-5.56-17.91c-1.23-2.09-2.13-3.3-2.06-3.36a4.07,4.07,0,0,1,.71.8,27.81,27.81,0,0,1,1.66,2.37,36.58,36.58,0,0,1,5.62,18.08,25.87,25.87,0,0,1,0,2.89A4.06,4.06,0,0,1,253.59,351.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.79,348.92a29,29,0,0,1,.25-3.08,39.28,39.28,0,0,0-.14-7.4,38.7,38.7,0,0,0-1.55-7.24c-.57-1.82-1-2.91-.94-2.95a2.79,2.79,0,0,1,.41.73,21.38,21.38,0,0,1,.88,2.1,32.12,32.12,0,0,1,1.7,14.8c-.12.95-.25,1.72-.37,2.24A3,3,0,0,1,259.79,348.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.75,336.05s0-.19-.23-.38a1.18,1.18,0,0,1-.41-.44c-.11-.21-.19-.46-.33-.7-.27-.51-.94-.89-1.42-1.63a10.57,10.57,0,0,1-1.2-2.64,17.75,17.75,0,0,0-3.44-6.48,29,29,0,0,0-3.09-3.08,33,33,0,0,0-3.73-2.85,30.6,30.6,0,0,0-4-2.47l-4-1.94c-1.26-.6-2.44-1.22-3.59-1.71l-3.2-1.37a12.69,12.69,0,0,1-1.39-.63c-.43-.25-.78-.53-1.14-.73l-1-.55c-.32-.17-.59-.4-.83-.55-.49-.31-.92-.48-1.2-.63s-.42-.23-.41-.25a2,2,0,0,1,.45.16,9.45,9.45,0,0,1,1.27.55,13.9,13.9,0,0,0,1.9,1c.39.19.76.47,1.16.69s.9.38,1.38.59l3.22,1.3c1.15.47,2.35,1.09,3.63,1.68l4,1.91a30.31,30.31,0,0,1,4.05,2.5,30.92,30.92,0,0,1,3.78,2.9,28,28,0,0,1,3.12,3.15,17.61,17.61,0,0,1,3.42,6.67,11.05,11.05,0,0,0,1.09,2.6c.42.7,1.07,1.11,1.35,1.69.15.28.21.54.3.73a1.32,1.32,0,0,0,.34.44C306.85,335.84,306.76,336.07,306.75,336.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.46,464.58c-.14,0-.26-25.3-.26-56.51s.12-56.51.26-56.51.26,25.3.26,56.51S178.61,464.58,178.46,464.58Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilloutPana);
export default __webpack_public_path__ + "static/media/Fill out-pana.1d7f2b0ddb4baa69210bd12bbd824e2e.svg";
export { ForwardRef as ReactComponent };